var Testimonials = {};

//--------------
// Variable
//--------------

Testimonials.carousel = null;

/**
 * Testimonials init
 * @return {void}
 */

Testimonials.initCarousel = function(carousel) {
	Testimonials.carousel = new App.Swiper(carousel, {
		loop: true,
		speed: 800,
		navigation: {
			nextEl: $(carousel).closest('.js-testimonials-wrapper').find('.swiper-button-next'),
			prevEl: $(carousel).closest('.js-testimonials-wrapper').find('.swiper-button-prev'),
		},
		centeredSlides: true,
		slidesPerView: 'auto',
	});
}

//--------------
// Execution
//--------------

Testimonials.init = function(){
	Testimonials.initCarousel('.js-testimonials');
}

Testimonials.init();

module.exports = Testimonials;
